/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechStorageUsbIcon16Solid = forwardRef('TechStorageUsbIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.951 7.294a1.25 1.25 0 0 1-.001 1.767l-4.773 4.773a4.25 4.25 0 0 1-6.01-6.01L6.938 3.05a1.25 1.25 0 0 1 1.767-.001l2.12-2.122a1.25 1.25 0 0 1 1.769 0l2.477 2.478a1.25 1.25 0 0 1 0 1.768l-2.12 2.121ZM9.766 4.11l2.125 2.125 1.944-1.945-2.124-2.124-1.945 1.944Z" })));
});
